import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';
import shouldOpenModal from 'App/services/Modal/shouldOpenModal';

/**
 * The single way to open the edit-activity modal (WEB-9979): the React modal
 * where `shouldOpenModal('EditActivity')` allows — `REACT_EDIT_ACTIVITY` on and
 * no active `activity_edit` UI script — and the Angular `editActivity` modal
 * otherwise.
 *
 * It resolves with the saved activity and rejects on dismiss, as `$upModal.open`
 * did and as the `$upModal` forward (`forwardToReactModal`) does today, so a
 * caller's `.then` only runs after a save.
 *
 * Its own file, not re-exported from the modal's index, so importing it does not
 * pull the modal component into the caller's bundle.
 */
export const openEditActivity = asyncModalAdapter({
	upModalName: 'editActivity',
	openModalName: 'EditActivity',
	featureFlag: 'REACT_EDIT_ACTIVITY',
	extraCondition: () => shouldOpenModal('EditActivity'),
	rejectOnEmpty: true
});
